import { z } from "zod";

const environmentSchema = z.object({
  VITE_ADMIN_API_ORIGIN: z.union([
    z.literal("SELF"),
    z.string().url().startsWith("https://"),
  ]),
  VITE_DEPLOYMENT_ENVIRONMENT: z.enum(["DEVELOPMENT", "STAGING", "PRODUCTION"]),
});

const rawOrigin: unknown = import.meta.env.VITE_ADMIN_API_ORIGIN;
const rawEnvironment: unknown = import.meta.env.VITE_DEPLOYMENT_ENVIRONMENT;

const defaults =
  import.meta.env.MODE === "test" || import.meta.env.MODE === "development"
    ? {
        VITE_ADMIN_API_ORIGIN:
          (typeof rawOrigin === "string" ? rawOrigin : undefined) ??
          "https://api.admin.localhost",
        VITE_DEPLOYMENT_ENVIRONMENT:
          (typeof rawEnvironment === "string" ? rawEnvironment : undefined) ??
          "DEVELOPMENT",
      }
    : import.meta.env;

const parsed = environmentSchema.parse(defaults);
export const adminEnvironment = {
  ...parsed,
  VITE_ADMIN_API_ORIGIN:
    parsed.VITE_ADMIN_API_ORIGIN === "SELF"
      ? window.location.origin
      : parsed.VITE_ADMIN_API_ORIGIN,
};
